import axios from "../lib/axios";

function removeEmptyEntries(obj) {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => {
      if (value === null || value === undefined || value === '') {
        return false;
      }
      if (typeof value === 'object' && Object.keys(value).length === 0) {
        return false;
      }
      return true;
    })
  );
}


export const fetchLocations = (params = {}) => {
  const url = `/locations`;

  return axios
    .get(url, {
      params: params,
    })
    .then((response) => {
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      return Promise.reject(error.response.data);
    });
};

export const fetchLocation = (id) => {
  const url = `/locations/${id}`;

  return axios
    .get(url)
    .then((response) => {
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      return Promise.reject(error.response.data);
    });
};

export function updateLocation(id, params) {
  const url = `/locations/${id}`;
  console.log(url)
  return axios
    .put(url, params)
    .then((response) => {
      return Promise.resolve(response.data)
    })
    .catch((error) => {
      return Promise.reject(error.response.data);
    })
}

export function fetchStates() {
  const url = `/locations/states`;

  return axios
    .get(url)
    .then((response) => {
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      return Promise.reject(error.response.data);
    });
}

export function exportLocations(params) {
  const url = new URL(`${window.location.protocol}//${window.location.host}/locations/export`);
  const queryParams = new URLSearchParams(removeEmptyEntries(params));
  url.search = queryParams.toString();

  return axios.get(url.toString(), {
    headers: {
      'Content-Type': 'text/csv',
      'Accept': 'text/csv'
    }})
    .then((response) => {
      const blob = new Blob([response.data], { type: 'text/csv'});
      return Promise.resolve(blob)
    }).catch((error) => {
      return Promise.reject(error);
    })
}

export function importLocations(csv) {
  const url = `/locations/import`;
  const formData = new FormData();
  formData.append('file', csv);

  return axios.post(url, formData, { headers: {
    'Content-Type': 'multipart/form-data'
  }}).then((data) => {
    return Promise.resolve()
  }).catch((error) => {
    console.error(error)
    return Promise.reject(error);
  })
}